import { useDispatch, useSelector } from "react-redux";
import BackButton from "../../../../components/BackButton";
import { navigatedToPreviousStep } from "../../../../redux/slice/bookingCreation/bookingCreationSlice";
import { RootState } from "../../../../redux/store";
import { BookingCreationStep } from "../../../bookLocation/voucher/GiftVoucherPage";

const BookLocationNavigateBackAction = () => {
  const dispatch = useDispatch();
  const step = useSelector((state: RootState) => state.bookingCreation.step);
  const locations = useSelector((state: RootState) => state.booking.locations);

  // Show back button if:
  // 1. Not on first step (orderData)
  // 2. OR if on booking summary step
  const showBackButton = step !== BookingCreationStep.orderData || (locations?.length > 1 && step === BookingCreationStep.bookingSummary as number);

  const handleBackClick = () => {
    dispatch(navigatedToPreviousStep());
  };

  return <BackButton hidden={!showBackButton} onClick={handleBackClick} />;
};

export default BookLocationNavigateBackAction;
